import { track } from '@sloyd/analytics';
import * as api from '@sloyd/api';
import { actions, selectors } from '@sloyd/store-base';
import { toast } from '@sloyd/ui';
import { delay, put, select, take } from 'saga-ts';
import { invokeEvent } from 'shared-base';

export function* dataGuard() {
  console.time('dataGuard');
  const appState = yield* select(selectors.raw.$rawAppState);
  const { isDataReady } = appState;

  if (!isDataReady) {
    yield take('DATA_READY');
  }

  console.timeEnd('dataGuard');

  return true;
}

export function* authGuard() {
  console.time('authGuard');
  const appState = yield* select(selectors.raw.$rawAppState);
  const { isAuthenticated } = appState;

  if (!isAuthenticated) {
    yield take('AUTH_COMPLETED');
  }

  console.timeEnd('authGuard');

  return true;
}

export function* unityGuard() {
  console.time('unityGuard');
  const appState = yield* select(selectors.raw.$rawAppState);
  const { isUnityReady } = appState;

  if (!isUnityReady) {
    yield take('UNITY_READY');
  }

  console.timeEnd('unityGuard');

  return true;
}

export function* showSubscribeModal(message: string) {
  try {
    track('Subscribe Modal Shown');

    toast.show(message, {
      cta: {
        buttonText: 'Subscribe',
        onCta: () => {
          track('Subscribe Modal CTA');
          invokeEvent('nav', { path: '/pricing' });
        },
        analyticsId: 'Toast Subscribe',
      },
      flavour: 'warning',
    });
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* subscriberGuard(message: string) {
  console.time('subscriberGuard');
  const isSubscriber = yield* select(selectors.base.$isSubscriber);

  if (!isSubscriber) {
    yield showSubscribeModal(message);
    return false;
  }

  console.timeEnd('subscriberGuard');

  return true;
}

export function* exportGuard() {
  console.time('exportGuard');
  try {
    yield put(actions.appState.patch({ isCharging: true }));
    yield delay(10);
    const resCanExport = yield api.user.canExport();
    yield put(actions.appState.patch({ isCharging: false }));

    if (!resCanExport || !resCanExport.data) {
      yield showSubscribeModal('Unlock downloads with a subscription!');
      return false;
    }

    console.timeEnd('exportGuard');

    return true;
  } catch (err) {
    yield put(actions.appState.patch({ isCharging: false }));
    invokeEvent('sentry', { err });
    return false;
  }
}
